import { TimelyIcon } from 'components/Icons';
import { DateTime } from 'luxon';
import React from 'react';
import styles from './AuthPage.module.scss';
import Testimonials from './Testimonials';

interface AuthPageLayoutProps {
  title: React.ReactNode;
  children: React.ReactNode;
  bottomLink: React.ReactNode;
}

const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({ title, children, bottomLink }) => (
  <div className={styles.authPage}>
    <header>
      <TimelyIcon />
      <h1>{title}</h1>
    </header>
    <main>
      <Testimonials />
      <div className={styles.formContainer}>
        <div className={styles.inner}>{children}</div>
        <div className={styles.bottomLink}>{bottomLink}</div>
      </div>
    </main>
    <footer className={styles.footer}>Copyright {DateTime.now().year} Timely AS</footer>
  </div>
);

export default AuthPageLayout;
